module.exports = __webpack_public_path__ + "static/media/SixthContainerImage2.82538e0a.webp";